import React, { useContext } from 'react';
import './Footer.css';
import { LocaleContext } from '../locale';

export default function Footer() {
  const { t } = useContext(LocaleContext);
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-col">
          <div className="brand-small">{t('nav.brandTitle')}</div>
          <p className="muted">{t('footer.curated')}</p>
          <small className="muted">{t('footer.copyright', { year })}</small>
        </div>

        <div className="footer-col">
          <h4>{t('footer.shop')[0] ? 'Shop' : 'Shop'}</h4>
          {/* map shop links if needed */}
          <a>{t('footer.shop')[0]}</a>
          <a>{t('footer.shop')[1]}</a>
          <a>{t('footer.shop')[2]}</a>
        </div>

        <div className="footer-col">
          <h4>{t('footer.support')[0] ? 'Support' : 'Support'}</h4>
          <a>{t('footer.support')[0]}</a>
          <a>{t('footer.support')[1]}</a>
          <a>{t('footer.support')[2]}</a>
        </div>

       
      </div>
    </footer>
  );
}
